/**
 * @stable
 */
export enum OfferStatus {
    Offered = 'offered',
    OptedIn = 'opted-in',
    Expired = 'expired',
    NotOffered = 'not-offered',
    OptedOut = 'opted-out',
    Error = 'error',
    Invalid = 'invalid',
    Unknown = 'unknown',
}

export enum QueryParam {
    OfferId = 'offerId',
    OfferType = 'offerType',
}
